import React, { useState } from "react";

const CurrencyInput = ({ amount, setAmount, currency, setCurrency, label }) => {
  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const handleAmountChange = (event) => {
    const value = event.target.value;
    // Validar que el valor ingresado sea un número o esté vacío
    if (!isNaN(value) || value === "") {
      setAmount(value);
    }
  };

  return (
    <div className="relative">
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">
          {label}
          {/* Asterisco con el color solicitado */}
        </label>
      )}
      <input
        type="number"
        placeholder={label ? "" : "Monto"}
        value={amount}
        onChange={handleAmountChange}
        className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-20 focus:outline-none focus:ring"
      />
      <select
        value={currency}
        onChange={handleCurrencyChange}
        className={`poppins-medium text-xs absolute right-3 ${
          label
            ? "top-3/4 transform -translate-y-3/4"
            : "top-2/4 transform -translate-y-2/4"
        } bg-transparent focus:outline-none`}
      >
        <option value="1">PYG</option>
        <option value="2">USD</option>
      </select>
    </div>
  );
};

export default CurrencyInput;
